import isEmpty from "is-empty";
import { isAddress } from "../helper/custommath"

export const regValidate = async (params) => {
    let errors = {}
    let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    let pwdregex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

    if (isEmpty(params.name)) {
        errors.name = "UserName is required";
    }

    if (params.joinmethod === "email") {
        if (isEmpty(params.email)) {
            errors.email = "Email is required";
        } else if (!emailRegex.test(params.email)) {
            errors.email = "Email is invalid";
        }
    }


    if (isEmpty(params.password)) {
        errors.password = "Password field is required";
    } else if (!pwdregex.test(params.password)) {
        errors.password = "Your password must be at least 8 characters long and contain at least one lowercase letter, one uppercase letter, one number, and one special character";
    }


    if (isEmpty(params.confirmpassword)) {
        errors.confirmpassword = "Confirm password field is required";
    } else if (params.password != params.confirmpassword) {
        errors.confirmpassword = "Password & Confirm password do not match";
    }

    if (params.joinmethod === "phone") {
        if (isEmpty(params.phoneNo)) {
            errors.phoneNo = "Phone Number is required";
        }
    }

    // if (isEmpty(params.referralId)) {
    //     errors.referralId = "Referral ID is required";
    // }

    if (!params.terms) {
        errors.terms = "You must agree to the Terms and Conditions";
    }

    return errors;
}

export const regInputValidate = (params, name) => {
    let errors = {}
    let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    let pwdregex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
    if (isEmpty(params.name) && name == "name") {
        errors.name = "UserName is required";
    }

    if (params.joinmethod === "email" && name === "joinmethod") {
        if (isEmpty(params.email) && name === "email") {
            errors.email = "Email is required";
        } else if (!emailRegex.test(params.email) && name === "email") {
            errors.email = "Email is invalid";
        }
    }


    if (isEmpty(params.password) && name === "password") {
        errors.password = "Password field is required";
    } else if (!pwdregex.test(params.password) && name === "password") {
        errors.password = "Your password must be at least 8 characters long and contain at least one lowercase letter, one uppercase letter, one number, and one special character";
    }

    if (isEmpty(params.confirmpassword) && name === "confirmpassword") {
        errors.confirmpassword = "Confirm password field is required";
    } else if (params.password != params.confirmpassword && name === "confirmpassword") {
        errors.confirmpassword = "Password & Confirm password do not match";
    }


    if (params.joinmethod === "phone" && name === "joinmethod") {
        if (isEmpty(params.phoneNo) && name === "phoneNo") {
            errors.phoneNo = "Phone Number is required";
        }
    }

    // if (isEmpty(params.referralId) && name === "referralId") {
    //     errors.referralId = "Referral ID is required";
    // }


    if (!params.terms && name === "terms") {
        errors.terms = "You must agree to the Terms and Conditions";
    }

    return errors;
}


export const loginValidate = async (params) => {
    console.log('para232323ms: ', params);
    let errors = {}
    let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    let emailRegex1 = /^[a-zA-Z0-9.]+@(yopmail\.com|gmail\.com)$/;

    if (isEmpty(params.email)) {
        errors.email = "Email / PhoneNumber is required";
    }

    // if (isEmpty(params.email)) {
    //     errors.email = "Email is required";
    // } else if (!emailRegex.test(params.email)) {
    //     errors.email = "Email is invalid";
    // }
    //  else if (!emailRegex.test(params.email)) {
    //     errors.email = "Email is invalid";
    // } else if (!emailRegex1.test(params.email)) {
    //     errors.email = "Only letters(a-z,A-Z),numbers (0-9), and periods(.) are allowed";
    // }

    if (isEmpty(params.password)) {
        errors.password = "Password field is required";
    }

    return errors;
}

export const loginInputValidate = (params, name) => {
    let errors = {}
    let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    let emailRegex1 = /^[a-zA-Z0-9.]+@(yopmail\.com|gmail\.com)$/;

    if (isEmpty(params.email) && name === "email") {
        errors.email = "Email / PhoneNumber is required";
    }

    // if (isEmpty(params.email) && name === "email") {
    //     errors.email = "Email is required";
    // } else if (!emailRegex.test(params.email) && name === "email") {
    //     errors.email = "Email is invalid";
    // }
    //  else if (!emailRegex.test(params.email) && name === "email") {
    //     errors.email = "Email is invalid";
    // } else if (!emailRegex1.test(params.email) && name === "email") {
    //     errors.email = "Only letters(a-z,A-Z),numbers (0-9), and periods(.) are allowed";
    // }

    if (isEmpty(params.password) && name === "password") {
        errors.password = "Password field is required";
    }

    return errors;
}


export const forgotValidate = async (params) => {
    let errors = {}
    let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    let emailRegex1 = /^[a-zA-Z0-9.]+@(yopmail\.com|gmail\.com)$/;

    if (isEmpty(params.email)) {
        errors.email = "Enter your email or Phone number";
    }
    // else if (!emailRegex.test(params.email)) {
    //     errors.email = "Email is invalid";
    // } else if (!emailRegex1.test(params.email)) {
    //     errors.email = "Only letters(a-z,A-Z),numbers (0-9), and periods(.) are allowed";
    // }

    return errors;
}

export const forgotInputValidate = (params, name) => {
    let errors = {}
    let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    let emailRegex1 = /^[a-zA-Z0-9.]+@(yopmail\.com|gmail\.com)$/;

    if (isEmpty(params.email) && name === "email") {
        errors.email = "Email is required";
    } else if (!emailRegex.test(params.email) && name === "email") {
        errors.email = "Email is invalid";
    } else if (!emailRegex1.test(params.email) && name === "email") {
        errors.email = "Only letters(a-z,A-Z),numbers (0-9), and periods(.) are allowed";
    }

    return errors;
}

export const resetValidate = async (params) => {
    let errors = {}
    let pwdregex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

    if (isEmpty(params.newpassword)) {
        errors.newpassword = "New Password field is required";
    } else if (!pwdregex.test(params.newpassword)) {
        errors.newpassword = "Your new password must be at least 8 characters long and contain at least one lowercase letter, one uppercase letter, one number, and one special character";
    }

    if (isEmpty(params.confirmnewpassword)) {
        errors.confirmnewpassword = "Confirm new password field is required";
    } else if (params.newpassword != params.confirmnewpassword) {
        errors.confirmnewpassword = "New Password & Confirm password do not match";
    }
    return errors;
}

export const resetInputValidate = (params, name) => {
    let errors = {}
    let pwdregex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

    if (isEmpty(params.newpassword) && name === "newpassword") {
        errors.password = "New Password field is required";
    } else if (!pwdregex.test(params.newpassword) && name === "newpassword") {
        errors.newpassword = "Your new password must be at least 8 characters long and contain at least one lowercase letter, one uppercase letter, one number, and one special character";
    }

    if (isEmpty(params.confirmnewpassword) && name === "confirmnewpassword") {
        errors.confirmnewpassword = "Confirm new password field is required";
    } else if (params.newpassword != params.confirmnewpassword && name === "confirmnewpassword") {
        errors.confirmnewpassword = "New Password & Confirm password do not match";
    }

    return errors;
}




export const otpValidate = async (params) => {
    let errors = {}

    if (isEmpty(params.otp)) {
        errors.otp = "OTP is required";
    } else if (isNaN(params.otp)) {
        errors.otp = "invalid OTP";
    }

    return errors;
}

export const otpInputValidate = (params, name) => {
    let errors = {}

    if (isEmpty(params.otp) && name == 'otp') {
        errors.otp = "OTP is required";
    } else if (isNaN(params.otp) && name == 'otp') {
        errors.otp = "invalid OTP";
    }

    return errors;
}

export const kycValidate = (formData) => {
    const errors = {};

    if (!formData.idType) {
        errors.idType = "Please select an ID type";
    }

    if (!formData.frontImage) {
        errors.frontImage = "Front image is required";
    }

    if (formData.idType !== "2" && !formData.backImage) {
        errors.backImage = "Back image is required";
    }

    if (!formData.walletAddress) {
        errors.walletAddress = "Wallet address is required";
    } else if (!/^0x[a-fA-F0-9]{40}$/.test(formData.walletAddress)) {
        errors.walletAddress = "Invalid wallet address";
    }

    if (!formData.agreeTerms) {
        errors.agreeTerms = "You must agree to the terms and conditions";
    }
    return errors
}

export const kycInputValidate = (value, name) => {
    const errors = {};
    console.log(value, name, 'value, name')
    if (!value && name == "idType") {
        errors.idType = "Please select an ID type";
    }

    if (!value && name == "frontImage") {
        errors.frontImage = "Front image is required";
    }

    if (value !== "2" && !value && name == "backImage") {
        errors.backImage = "Back image is required";
    }

    if (!value && name == "walletAddress") {
        errors.walletAddress = "Wallet address is required";
    } else if (!/^0x[a-fA-F0-9]{40}$/.test(value) && name == "walletAddress") {
        errors.walletAddress = "Invalid wallet address";
    }

    if (!value && name == "agreeTerms") {
        errors.agreeTerms = "You must agree to the terms and conditions";
    }
    return errors
}

export const walletValidate = async (params) => {
    let errors = {}

    if (isEmpty(params.wallet)) {
        errors.wallet = "Wallet Address is required";
    } else if (!isAddress(params.wallet)) {
        errors.wallet = "Invalid Address";
    }

    return errors;
}

export const walletInputValidate = (params, name) => {
    let errors = {}

    if (isEmpty(params.wallet) && name == 'wallet') {
        errors.wallet = "Wallet Address is required";
    } else if (!isAddress(params.wallet) && name == 'wallet') {
        errors.wallet = "Invalid Address";
    }

    return errors;
}
